// extracted by mini-css-extract-plugin
export var connectionButton = "_bg-1";
export var connectionButtonFloating = "_bg-2";
export var connectionContainer = "_bg-0";
export var rightPanel = "_bg-6";
export var stepCard = "_bg-3";
export var stepCardSubtitle = "_bg-5";
export var stepCardText = "_bg-4";